var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 2.66634H14.5V0.833008H12.6667V2.66634H5.33333V0.833008H3.5V2.66634H2.58333C1.56583 2.66634 0.759167 3.49134 0.759167 4.49967L0.75 17.333C0.75 18.3413 1.56583 19.1663 2.58333 19.1663H15.4167C16.425 19.1663 17.25 18.3413 17.25 17.333V4.49967C17.25 3.49134 16.425 2.66634 15.4167 2.66634ZM15.4167 17.333H2.58333V8.16634H15.4167V17.333ZM6.25 11.833H4.41667V9.99967H6.25V11.833ZM9.91667 11.833H8.08333V9.99967H9.91667V11.833ZM13.5833 11.833H11.75V9.99967H13.5833V11.833ZM6.25 15.4997H4.41667V13.6663H6.25V15.4997ZM9.91667 15.4997H8.08333V13.6663H9.91667V15.4997ZM13.5833 15.4997H11.75V13.6663H13.5833V15.4997Z",
    fill: "#2ACF21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveCalendar);
export default __webpack_public_path__ + "static/media/active-calendar.effc5d495e71967f055fd3e9d672fa3f.svg";
export { ForwardRef as ReactComponent };